import DomesticMedicalExpensesMY from '@/content/my/benefit/domestic-medical-expenses-details';
import DomesticPABenefitsMY from '@/content/my/benefit/domestic-personal-accident-benefits';
import DomesticPersonalLiabilityDetailsBenefitMY from '@/content/my/benefit/domestic-personal-liability-details-benefit';
import DomesticPriceDetailsMY from '@/content/my/benefit/domestic-price-details';
import DomesticTravelBenefitsMY from '@/content/my/benefit/domestic-travel-inconveniences-benefits';
import InternationalMedicalExpensesMY from '@/content/my/benefit/international-medical-expenses-details';
import InternationalPABenefitsMY from '@/content/my/benefit/international-personal-accident-benefits';
import InternationalPersonalLiabilityDetailsMY from '@/content/my/benefit/international-personal-liability-details';
import InternationalPriceDetailsMY from '@/content/my/benefit/international-price-details';
import InternationalTravelBenefitsMY from '@/content/my/benefit/international-travel-inconveniences-benefits';
import PlanHighlightMY from '@/content/my/benefit/plan-highlight';
import FaqContentMY from '@/content/my/faq-content';
import DomesticCovidCoveragesPH from '@/content/ph/benefit/domestic-covid-coverages';
import DomesticMedicalExpensesPH from '@/content/ph/benefit/domestic-medical-expenses-details';
import DomesticOthersBenefitsPH from '@/content/ph/benefit/domestic-others';
import DomesticPABenefitsPH from '@/content/ph/benefit/domestic-personal-accident-benefits';
import DomesticPersonalLiabilityDetailsBenefitPH from '@/content/ph/benefit/domestic-personal-liability-details-benefit';
import DomesticPostTripMedicalPH from '@/content/ph/benefit/domestic-post-trip-medical-benefits';
import DomesticPriceDetailsPH from '@/content/ph/benefit/domestic-price-details';
import DomesticTravelBenefitsPH from '@/content/ph/benefit/domestic-travel-inconveniences-benefits';
import InternationalCovidCoveragesPH from '@/content/ph/benefit/international-covid-coverages';
import InternationalMedicalExpensesPH from '@/content/ph/benefit/international-medical-expenses-details';
import InternationalOthersDetailsPH from '@/content/ph/benefit/international-others';
import InternationalPABenefitsPH from '@/content/ph/benefit/international-personal-accident-benefits';
import InternationalPersonalLiabilityDetailsPH from '@/content/ph/benefit/international-personal-liability-details';
import InternationalPostTripMedicalPH from '@/content/ph/benefit/international-post-trip-medical-benefits';
import InternationalPriceDetailsPH from '@/content/ph/benefit/international-price-details';
import InternationalTravelBenefitsPH from '@/content/ph/benefit/international-travel-inconveniences-benefits';
import PlanHighlightPH from '@/content/ph/benefit/plan-highlight';
import FaqContentPH from '@/content/ph/faq-content';
import { Area, CountryCode, Entity } from '@/enums';

export const ProductLink = {
  [Entity.Insurance]: {
    [CountryCode.Malaysia]:
      'https://www.etiqa.com.my/v2/travel-insurance-takaful/tripcare-360-insurance',
    [CountryCode.Philippines]: 'https://shop.etiqa.com.ph/travelinsurance',
  },
  [Entity.Takaful]: {
    [CountryCode.Malaysia]:
      'https://www.etiqa.com.my/v2/travel-insurance-takaful/tripcare-360-takaful',
    [CountryCode.Philippines]: 'https://shop.etiqa.com.ph/travelinsurance',
  },
};

export const HomePageLink = {
  [CountryCode.Malaysia]: 'form.homepage.link.my',
  [CountryCode.Philippines]: 'https://www.etiqa.com.ph',
};

export const PersonalAccidentDoc = {
  [Area.Domestic]: {
    [CountryCode.Malaysia]: DomesticPABenefitsMY,
    [CountryCode.Philippines]: DomesticPABenefitsPH,
  },
  [Area.International]: {
    [CountryCode.Malaysia]: InternationalPABenefitsMY,
    [CountryCode.Philippines]: InternationalPABenefitsPH,
  },
};

export const MedicalExpesesDoc = {
  [Area.Domestic]: {
    [CountryCode.Malaysia]: DomesticMedicalExpensesMY,
    [CountryCode.Philippines]: DomesticMedicalExpensesPH,
  },
  [Area.International]: {
    [CountryCode.Malaysia]: InternationalMedicalExpensesMY,
    [CountryCode.Philippines]: InternationalMedicalExpensesPH,
  },
};

export const PersonalLiabilityDoc = {
  [Area.Domestic]: {
    [CountryCode.Malaysia]: DomesticPersonalLiabilityDetailsBenefitMY,
    [CountryCode.Philippines]: DomesticPersonalLiabilityDetailsBenefitPH,
  },
  [Area.International]: {
    [CountryCode.Malaysia]: InternationalPersonalLiabilityDetailsMY,
    [CountryCode.Philippines]: InternationalPersonalLiabilityDetailsPH,
  },
};

export const TravelInconveniencesDoc = {
  [Area.Domestic]: {
    [CountryCode.Malaysia]: DomesticTravelBenefitsMY,
    [CountryCode.Philippines]: DomesticTravelBenefitsPH,
  },
  [Area.International]: {
    [CountryCode.Malaysia]: InternationalTravelBenefitsMY,
    [CountryCode.Philippines]: InternationalTravelBenefitsPH,
  },
};

export const PostTripDoc = {
  [Area.Domestic]: DomesticPostTripMedicalPH,
  [Area.International]: InternationalPostTripMedicalPH,
};

export const OthersDoc = {
  [Area.Domestic]: DomesticOthersBenefitsPH,
  [Area.International]: InternationalOthersDetailsPH,
};

export const CovidCoveragesDoc = {
  [Area.Domestic]: DomesticCovidCoveragesPH,
  [Area.International]: InternationalCovidCoveragesPH,
};

export const PlanHighlightDoc = {
  [CountryCode.Malaysia]: PlanHighlightMY,
  [CountryCode.Philippines]: PlanHighlightPH,
};

export const PriceDetailsDoc = {
  [Area.Domestic]: {
    [CountryCode.Malaysia]: DomesticPriceDetailsMY,
    [CountryCode.Philippines]: DomesticPriceDetailsPH,
  },
  [Area.International]: {
    [CountryCode.Malaysia]: InternationalPriceDetailsMY,
    [CountryCode.Philippines]: InternationalPriceDetailsPH,
  },
};

export const FAQContent = {
  [CountryCode.Malaysia]: FaqContentMY,
  [CountryCode.Philippines]: FaqContentPH,
};
